// WEEKLY-3 (2026-07-27) — Tipos do módulo Reuniões Semanais.
// Contrato de dados: backend no comercial-engine (handlers de reuniões),
// tabelas operacao.reunioes / operacao.reuniao_encaminhamentos /
// operacao.reunioes_config (migration 1787400000000_reunioes-semanais.sql).

export type ReuniaoStatus = 'agendada' | 'briefing_gerado' | 'realizada' | 'consolidada';
export type EncamStatus = 'proposto' | 'aceito' | 'convertido' | 'descartado';
export type ReuniaoOrigem = 'sistema' | 'notion_import';

// Linha da listagem (op_reuniao_listar)
export interface ReuniaoResumo {
  id: string;
  tipo: string;                        // 'weekly'
  titulo: string;
  data_reuniao: string | null;         // YYYY-MM-DD
  semana_ref: string;                  // segunda-feira da semana (YYYY-MM-DD)
  status: ReuniaoStatus;
  origem: ReuniaoOrigem;
  criado_em: string;
  n_encaminhamentos: number | string;  // COUNT do PG pode vir como string
  n_convertidos: number | string;
}

// Registro completo (op_reuniao_obter)
export interface Reuniao extends ReuniaoResumo {
  briefing_html: string | null;
  pauta_html: string | null;
  ata_html: string | null;
  transcricao_s3_key: string | null;
  resumo_ia: any;
  participantes: string[];
  notion_page_id: string | null;
  criado_por: string | null;
  atualizado_em: string | null;
}

export interface Encaminhamento {
  id: string;
  descricao: string;
  responsavel_email: string | null;
  contrato_id: string | null;
  contrato_numero?: string | null;
  prazo: string | null;                // YYYY-MM-DD
  status: EncamStatus;
  atividade_id: string | null;
  origem: 'ia' | 'manual';
}

export interface ContratoOpcao {
  id: string;
  numero: string | null;
  titulo: string | null;
}

export interface ReunioesConfig {
  ativo: boolean;
  destinatarios_briefing: string[];
}

export const STATUS_REUNIAO: Record<ReuniaoStatus, { label: string; cor: string }> = {
  agendada:        { label: 'Agendada',        cor: 'default' },
  briefing_gerado: { label: 'Briefing gerado', cor: 'blue' },
  realizada:       { label: 'Realizada',       cor: 'orange' },
  consolidada:     { label: 'Consolidada',     cor: 'green' },
};

export const STATUS_ENCAM: Record<EncamStatus, { label: string; cor: string }> = {
  proposto:   { label: 'Proposto',    cor: 'gold' },
  aceito:     { label: 'Aceito',      cor: 'blue' },
  convertido: { label: 'ação criada', cor: 'green' },
  descartado: { label: 'Descartado',  cor: 'default' },
};

// Códigos da matriz de permissões (migration seedou no catálogo)
export const PERM_VER = 'operacional.reunioes.ver';
export const PERM_GERENCIAR = 'operacional.reunioes.gerenciar';
export const PERM_CONSOLIDAR = 'operacional.reunioes.consolidar';
